import { React, useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Radio,
  AutoComplete,
  Tooltip,
} from "antd";
import { Collapse } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DisabledButtonStyle, Styled, StyledTab } from "../../pageStyled";
import { uploadPODocuments } from "../../../Services/uploadServices";
import { DatePicker } from "antd";
import {
  DatePickerY,
  GlobalSet,
  DisabledStyles,
  DeliveryaddressSpacing,
} from "../../pageStyled";
import {
  addPo,
  addDummyOrders,
  getPackagingList,
  addSo,
} from "../../../Services/orderServices";
import { Country, State } from "country-state-city";
import moment from "moment";
import {
  getProductDetails,
  getProductsData,
  getProducts,
} from "../../../Services/productServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { BackTop } from "antd";
import {
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import { getCustomerDetails } from "../../../Services/customerServices";
import { getMachineGradeSelectForConfig } from "../../../Services/settingsServices";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
  CoversionFactorCMToUnits,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import { useNavigate, useLocation } from "react-router-dom";
import { toHandlePOName } from "../../../Utils/helper/helper";
import {
  getJobCardSerialNumberParam,
  updateOrderCreationConfig,
  getAllGrades,
  getGradeQualities,
  getAllGradesWithQualities,
  getGradeProductParameter,
} from "../../../Services/settingsServices";
import { ModalPopup } from "../../../Components/Modal/modal";
import warning from "../../../Assets/Icons/warning.png";


const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "2px solid #dfe1e6",
    "border-radius": "8px",
    width: "439px",
    "background-color": "var(--form-element-bg)",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
    margin-top: 4px;
    width: 439px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

const { Option } = Select;
const grainTypeData = ["Long Grain", "Short Grain"];
const rewinderType = [
  { label: "Constant", value: "constant" },
  { label: "Range", value: "range" },
];
const plyData = [
  { label: "Single Ply", value: 1 },
  { label: "Double Ply", value: 2 },
  { label: "3-Ply", value: 3 },
  { label: "4-Ply", value: 4 },
];
const { TextArea } = Input;
const { Panel } = Collapse;

const AddNewDummyOrderDrawer = (props) => {
  const soNo = useRef()
  const history = useNavigate();
  const [form] = Form.useForm();
  const scrollRef = useRef(null);
  const [orderTypes, setOrderTypes] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedGrade, setSelectedGrade] = useState();
  const [selectedQuality, setSelectedQuality] = useState();
  const [selectedPly, setSelectedPly] = useState();
  const [selectedBulk, setBulk] = useState();
  const [selectedMoisture, setMoisture] = useState();
  const [selectedGSM, setGSM] = useState();
  const [selectedBF, setBF] = useState();
  const [orderQuantityTabArray, setOrderQuantityTabArray] = useState([]);
  const [orderQuantity, setOrderQuantity] = useState("weight");
  const [outerDiameter, setOuterDiameter] = useState("constant");
  const [measurementData, setMeasurementData] = useState();
  const [dimesionUnitList, setDimesionUnitList] = useState([]);
  const [weightUnitList, setWeightUnitList] = useState([]);
  const [settingsData, setSettingsData] = useState();
  const [reelCoreData, setReelCoreData] = useState();
  const [reelValues, setReelvalues] = useState();
  const [coreValues, setCoreValues] = useState();
  const [selectedReelOD, setSelectedReelOD] = useState();
  const [reelODValidationError, setReelODValidationError] = useState(false);
  const [coreOdValidationError, setCoreOdValidationError] = useState(false);
  const [rangeValidationError, setRangeValidationError] = useState(false);
  const [grainValue, setGrain] = useState("");
  const [products, setProducts] = useState([]);
  const [mixedGrain, setMixedGrain] = useState(false);
  const [grainChanges, setGrainChanges] = useState(true);
  const [isMixedGrainEnabled, setMixedGrainEnabled] = useState(false);
  const [isToleranceDisabled, setToleranceDisabled] = useState(false);
  const [unitPlaceholder, setUnitPlaceholder] = useState("");
  const [orderUpperTol, setOrderUpperTol] = useState("");
  const [orderLowerTol, setOrderLowerTol] = useState("");
  const [defaultUpperOrderTol, setDefaultUpperOrderTol] = useState("");
  const [defaultLowerOrderTol, setDefaultLowerOrderTol] = useState("");
  const [grades, setGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [showBF, setShowBf] = useState(false);
  const [showMoisture, setShowMoisture] = useState(false);
  const [grainToleranceData, setGrainTolData] = useState();
  const [details, setDetails] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [indexValue, setIndexValue] = useState();
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [productErrModal, setProductErrModal] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });

  useEffect(() => {
    (async () => {
      let typeData;
      getMachineGradeSelect()
        .then((response) => {
          const reelValue = response.data.data.settings.order_types[0].value;
          const sheetValue = response.data.data.settings.order_types[1].value;
          typeData =
            reelValue && sheetValue
              ? [
                { label: "Reel", value: "reel" },
                { label: "Sheet", value: "sheet" },
              ]
              : reelValue
                ? [{ label: "Reel", value: "reel" }]
                : sheetValue
                  ? [{ label: "Sheet", value: "sheet" }]
                  : [];
          setOrderTypes(typeData);
          // setSelectedType(typeData[0].value);

          setOrderQuantityTabArray([
            { label: "Weight", value: "weight" },
            {
              label: `${capitalize(typeData[0].value)}s`,
              value: typeData[0].value,
            },
          ]);
          setOrderQuantity("weight");
        })
        .catch((error) => console.log(error));
      let measurement_data;
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          measurement_data = unitData;
          setMeasurementData(unitData);

          form.setFieldsValue({
            dimensionUnit: unitData.data.units_management.length.default,
          });
          form.setFieldsValue({
            reelOD_unit: unitData.data.units_management.length.default,
          });
          setDimesionUnitList(unitData.data.units_management.length.data);

          form.setFieldsValue({
            weightUnit: unitData.data.units_management.weight.default,
          });
          setUnitPlaceholder(unitData.data.units_management.weight.default);

          setWeightUnitList(unitData.data.units_management.weight.data);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const response = await getReelCoreValues();
        if (!response.error) {
          setReelCoreData(response);
          const reelData = response.reel_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          const coreData = response.core_data.map((item) => {
            return {
              value: item[0] + " " + item[1],
            };
          });
          setCoreValues(coreData);
          setReelvalues(reelData);
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const resp = await getMachineGradeSelectForConfig();
        if (!resp.error) {
          setGrainTolData(resp?.data?.data);
          setGrain(
            resp?.data?.data?.settings.order_types[1]?.grain === "long"
              ? "Long Grain"
              : "Short Grain"
          );
          form.setFieldsValue({
            grain:
              resp?.data?.data?.settings.order_types[1]?.grain === "long"
                ? "Long Grain"
                : "Short Grain",
          });
          setMixedGrainEnabled(
            resp?.data?.data?.settings.order_types[1]?.mixed_grain
          );
          setToleranceDisabled(
            resp?.data?.data?.settings?.order_types[2]?.value
          );
          setDefaultUpperOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              .upper_tolerance
          );
          setDefaultLowerOrderTol(
            resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
              .lower_tolerance
          );
          form.setFieldsValue({
            order_upper_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                .upper_tolerance,
          });
          form.setFieldsValue({
            order_lower_tolerance:
              resp?.data?.data?.settings?.order_types[2]?.data?.order_tolerance
                .lower_tolerance,
          });
        }
      } catch (err) {
        console.log(err);
      }

      try {
        const settingsDataResp = await getJobCardSerialNumberParam();
        if (settingsDataResp) {
          setSettingsData(settingsDataResp);
          let settingDataValue =
            settingsDataResp?.data?.order_creation_config?.dummy_orders?.config;
          if (settingDataValue?.hasOwnProperty("ply")) {
            setSelectedPly(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["ply"]?.value
            );
          } else {
            setSelectedPly(1);
          }
          if (settingDataValue?.hasOwnProperty("type")) {
            form.setFieldsValue({
              type: settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["type"]?.value?.toLowerCase()
            });
            setSelectedType(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["type"]?.value?.toLowerCase()
            );
          } else {
            form.setFieldsValue({ type: typeData[0].value });
            setSelectedType(typeData[0].value);
          }
          if (settingDataValue?.hasOwnProperty("grade")) {
            setSelectedGrade(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["grade"]?.value
            );
          }
          if (settingDataValue?.hasOwnProperty("quality")) {
            setSelectedQuality(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["quality"]?.value
            );
          }
          if (settingDataValue?.hasOwnProperty("gsm")) {
            setGSM(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["gsm"]?.value
            );
          }
          if (settingDataValue?.hasOwnProperty("bulk")) {
            setBulk(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                ?.config["bulk"]?.value
            );
          }
          if (settingDataValue?.hasOwnProperty("burst_factor")) {
            setBF(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                        ?.config["burst_factor"]?.value
            );
          }
          if (settingDataValue?.hasOwnProperty("moisture")) {
            setMoisture(
              settingsDataResp?.data?.order_creation_config?.dummy_orders
                        ?.config["moisture"]?.value
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [props]);

  useEffect(() => {
    (async () => {
      try {
        if (settingsData) {
          const gradesData = await getAllGradesWithQualities("enabled");
          if (gradesData?.settings?.grades) {
            let settingDataValue =
              settingsData?.data?.order_creation_config?.dummy_orders?.config;
            if (settingDataValue?.hasOwnProperty("grade")) {
              let selectedGradeValue = gradesData?.settings?.grades?.filter(
                (ele) =>
                  ele.name ==
                  settingsData?.data?.order_creation_config?.dummy_orders
                    ?.config["grade"]?.value
              );
              setQualities(
                selectedGradeValue[0]?.qualities?.filter(
                  (ele) => ele.value === true
                )
              );
              setShowBf(selectedGradeValue[0]?.product["burst_factor"]);
              setShowMoisture(selectedGradeValue[0]?.product["moisture"]);
            }
            setGrades(gradesData?.settings?.grades);
          }
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [settingsData]);

  useEffect(() => {
    if (measurementData && reelCoreData && grainToleranceData && settingsData && selectedType) {
      if (form.getFieldValue("type")?.toLowerCase() == "reel" || selectedType == "reel") {
        form.setFieldsValue({
          reel_OD: reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od + " " + reelCoreData.default_reel_unit
            : "",
        });
        form.setFieldsValue({
          core_OD: reelCoreData.default_core_id
            ? reelCoreData.default_core_id + " " + reelCoreData.default_core_unit
            : "",
        });
        reelCoreData.default_reel_od
          ? setSelectedReelOD([
            {
              value:
                reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit,
            },
          ])
          : setSelectedReelOD([]);
      }
    }
  }, [measurementData, reelCoreData, grainToleranceData, settingsData, selectedType]);

  // useEffect(() => {
  //   if (products.length === 0 && selectedPly) {
  //     getProducts({
  //       status: "active",
  //       type: selectedType,
  //       ply: selectedPly,
  //       isPly: true,
  //     })
  //       .then((response) => {
  //         setProducts(response);
  //       })
  //       .catch((error) => {
  //         console.log("Error in fetching products list:", error);
  //       });
  //   }
  // }, [selectedType, selectedPly, props]);

  const handleClose = () => {
    scrollToTop();
    // setProductData();
    setGrain("");
    setMeasurementData();
    setReelCoreData();
    setGrainTolData();
    setSettingsData();
    setDefaultLowerOrderTol("");
    setDefaultUpperOrderTol("");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setCoreValues();
    setReelvalues();
    setMeasurementData();
    setMixedGrain(false);
    setGrainChanges(true);
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    setMixedGrainEnabled(false);
    setToleranceDisabled(false);
    setGrades([]);
    setSelectedType();
    setSelectedGrade();
    setSelectedPly();
    setSettingsData();
    setDetails();
    setBF();
    setGSM();
    setBulk();
    setSelectedQuality();
    form.resetFields();
    props.onCloseGrade();
  };

  const handleType = async (e) => {
    setSelectedType(e);
    if (e === "sheet") {
      form.setFieldsValue({ ply: 1 });
      setSelectedPly(1);
    } else {
      setSelectedPly();
      form.setFieldsValue({ ply: "" });
    }

    form.setFieldsValue({
      length: "",
      width: "",
      reel_OD: "",
      core_OD: "",
      weight: "",
      quantity: "",
    });

    form.setFieldsValue({
      dimensionUnit: measurementData.data.units_management.length.default,
    });
    form.setFieldsValue({
      weightUnit: measurementData.data.units_management.weight.default,
    });

    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    setOrderQuantity("weight");
    setOuterDiameter("constant");
    setOrderUpperTol("");
    setOrderLowerTol("");
    setSelectedReelOD([]);
    setOrderQuantityTabArray([
      { label: "Weight", value: "weight" },
      {
        label: `${capitalize(e)}s`,
        value: e,
      },
    ]);

    if (e === "reel") {
      setGrainChanges(false);
      form.setFieldsValue({
        reel_OD: reelCoreData?.default_reel_od
          ? reelCoreData?.default_reel_od +
          " " +
          reelCoreData?.default_reel_unit
          : "",
      });
      form.setFieldsValue({
        core_OD: reelCoreData?.default_core_id
          ? reelCoreData?.default_core_id +
          " " +
          reelCoreData?.default_core_unit
          : "",
      });
      reelCoreData?.default_reel_od
        ? setSelectedReelOD([
          {
            value:
              reelCoreData?.default_reel_od +
              " " +
              reelCoreData?.default_reel_unit,
          },
        ])
        : setSelectedReelOD([]);
    }

    if (e === "sheet") {
      form.setFieldsValue({ reel_OD: "" });
      form.setFieldsValue({ core_OD: "" });
      setSelectedReelOD([]);
      
      setGrain(
        grainToleranceData?.settings.order_types[1]?.grain === "long"
          ? "Long Grain"
          : "Short Grain"
      );
      form.setFieldsValue({
        grain:
          grainToleranceData?.settings.order_types[1]?.grain === "long"
            ? "Long Grain"
            : "Short Grain",
      });
      setMixedGrainEnabled(
        grainToleranceData?.settings.order_types[1]?.mixed_grain
      );
      setGrainChanges(true);
    }

    setToleranceDisabled(
      grainToleranceData?.settings?.order_types[2]?.value
    );
    setDefaultUpperOrderTol(
      grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
        .upper_tolerance
    );
    setDefaultLowerOrderTol(
      grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
        .lower_tolerance
    );
    form.setFieldsValue({
      order_upper_tolerance:
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .upper_tolerance,
    });
    form.setFieldsValue({
      order_lower_tolerance:
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .lower_tolerance,
    });

    setDetails([]);

  };

  const handleGrade = async (e) => {
    form.setFieldsValue({ quality: "" });
    setSelectedQuality("");
    let selectedGradeValue = grades?.filter((ele) => ele.name == e);
    setQualities(
      selectedGradeValue[0]?.qualities?.filter((ele) => ele.value === true)
    );
    setShowBf(selectedGradeValue[0]?.product["burst_factor"]);
    setShowMoisture(selectedGradeValue[0]?.product["moisture"]);
    setSelectedGrade(e);
  };

  const handleQuality = async (e) => {
    setSelectedQuality(e);
  };

  const handlePly = async (e) => {
    setSelectedPly(e);
    form.setFieldsValue({ ply: e });
  };

  const onGSMChange = async (e) => {
    setGSM(e.target.value);
   };

  const onBulkChange = async (e) => {
    setBulk(e.target.value);
   };

  const onInputChange = async (type, e) => {
    if (type == "BF") {
      setBF(e.target.value);
    }
    if (type == "moisture") {
      setMoisture(e.target.value);
    }
  };

  const onSizeChange = (value, type) => {
    if (type == "length") {
    }
    if (type == "width") {
    }
    if (type == "sizeUnit") {
    }
  };

  const onGrainChange = (e) => {
    setGrain(e);
  };

  const checkboxClicked = (e, type) => {
    if (type == "grainChangesChange") {
      setGrainChanges(e.target.checked);
    }
    if (type == "mixedGrainChange") {
      setMixedGrain(e.target.checked);
    }
  };

  const handleQuantityChange = (e) => {
    setOrderQuantity(e.target.value);
    form.setFieldsValue({
      weight: "",
      quantity: "",
      min_reel_od: "",
      max_reel_od: "",
      weightUnit: measurementData.data.units_management.weight.default
    });
    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    setOrderUpperTol("");
    setOrderLowerTol("");
    if (e.target.value == "reel") {
      setOuterDiameter("constant");
    }
    if (selectedType == "reel") {
      if (reelCoreData) {
        form.setFieldsValue({
          reel_OD: reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od +
            " " +
            reelCoreData.default_reel_unit
            : "",
        });
        form.setFieldsValue({
          core_OD: reelCoreData.default_core_id
            ? reelCoreData.default_core_id +
            " " +
            reelCoreData.default_core_unit
            : "",
        });
        reelCoreData.default_reel_od
          ? setSelectedReelOD([
            {
              value:
                reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit,
            },
          ])
          : setSelectedReelOD([]);
      }
    }else{
      form.setFieldsValue({ reel_OD: "" });
      form.setFieldsValue({ core_OD: "" });
      setSelectedReelOD([]);
    }
    if (e.target.value == "weight") {
      setToleranceDisabled(
        grainToleranceData?.settings?.order_types[2]?.value
      );
      setDefaultUpperOrderTol(
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .upper_tolerance
      );
      setDefaultLowerOrderTol(
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .lower_tolerance
      );
      form.setFieldsValue({
        order_upper_tolerance:
          grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
            .upper_tolerance,
      });
      form.setFieldsValue({
        order_lower_tolerance:
          grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
            .lower_tolerance,
      });
    }
  };

  const handleWeight = (e) => {
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_upper_tolerance"),
      "orderUpperTol"
    );
    calculateOrderTol(
      e.target.value,
      form.getFieldValue("order_lower_tolerance"),
      "orderLowerTol"
    );
  };

  const onChangeWeightUnit = (e) => {
    setUnitPlaceholder(e);
    form.setFieldsValue({ planning_weightUnit: e });
  };

  const onTolChange = (e, type) => {
    let weightValue = form.getFieldValue("weight");
    if (type == "upper_tol") {
      setDefaultUpperOrderTol(e.target.value);
      form.setFieldsValue({ order_upper_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderUpperTol");
    }
    if (type == "lower_tol") {
      setDefaultLowerOrderTol(e.target.value);
      form.setFieldsValue({ order_lower_tolerance: e.target.value });
      calculateOrderTol(weightValue, e.target.value, "orderLoweTol");
    }
  };

  const calculateOrderTol = (weight, tolValue, type) => {
    if (type == "orderUpperTol") {
      if (weight && tolValue) {
        let upperTol = (weight * (100 + parseFloat(tolValue))) / 100;
        setOrderUpperTol(parseFloat(upperTol).toFixed(3));
      } else {
        setOrderUpperTol(0.0);
      }
    } else {
      if (weight && tolValue) {
        let lowerTol = (weight * (100 - parseFloat(tolValue))) / 100;
        setOrderLowerTol(parseFloat(lowerTol).toFixed(3));
      } else {
        setOrderLowerTol(0.0);
      }
    }
  };

  const handleRewinderType = (e) => {
    setCoreOdValidationError(false);
    setOuterDiameter(e.target.value);
    if (e.target.value == "range") {
      form.setFieldsValue({ reelOD_unit: measurementData.data.units_management.length.default });
    } else {
      form.setFieldsValue({ min_reel_od: "" });
      form.setFieldsValue({ max_reel_od: "" });
      if (selectedType == "reel") {
        form.setFieldsValue({
          reel_OD: reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od +
            " " +
            reelCoreData.default_reel_unit
            : "",
        });
        reelCoreData.default_reel_od
          ? setSelectedReelOD([
            {
              value:
                reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit,
            },
          ])
          : setSelectedReelOD([]);
      }
    }
  };

  const handleCoreOD = (e) => {
    let reelOD = form.getFieldValue("reel_OD");
    if (orderQuantity == "reel" && selectedType == "reel") {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[reelOD?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;
      let reelOdValue = reelOD?.split(" ")[0] * reelodConversion;
      if (parseFloat(coreODValue) > (reelOD && parseFloat(reelOdValue))) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (outerDiameter == "constant") {
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;
      if (selectedReelOD?.length == 1) {
        let reelodConversion = orderDim_Rewinder_Unit_Conversion[selectedReelOD[0]?.value?.split(" ")[1]];
        let reelOdValue = selectedReelOD[0]?.value?.split(" ")[0] * reelodConversion;
        if (parseFloat(coreODValue) > parseFloat(reelOdValue)) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      } else if (selectedReelOD?.length > 1) {
        let dataArr = [];
        for (let ind = 0; ind < selectedReelOD.length; ind++) {
          let convertedValue = selectedReelOD[ind]?.value?.split(" ")[0] *
            orderDim_Rewinder_Unit_Conversion[selectedReelOD[ind]?.value?.split(" ")[1]];
          dataArr.push(convertedValue);
        }
        let minValue = Math.min(...dataArr);
        if (
          (coreODValue && parseFloat(coreODValue)) >
          (minValue && parseFloat(minValue))
        ) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
        }
      } else {
        setCoreOdValidationError(false);
      }
    } else if (outerDiameter == "range") {
      let rangeUnit = form.getFieldValue("reelOD_unit");
      let minReel = form.getFieldValue("min_reel_od");
      let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
      let reelODValue = minReel * minReelConversion;
      let coreodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
      let coreODValue = e?.split(" ")[0] * coreodConversion;

      if (
        (reelODValue && parseFloat(reelODValue)) <
        (e && parseFloat(coreODValue))
      ) {
        setRangeValidationError(true);
      } else {
        setRangeValidationError(false);
      }
    }
  };

  const handleReelOD = (e) => {
    let coreOD = form.getFieldValue("core_OD");
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let reelodConversion = orderDim_Rewinder_Unit_Conversion[e?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    let reelOdValue = e?.split(" ")[0] * reelodConversion;
    if (parseFloat(reelOdValue) < (coreOD && parseFloat(coreODValue))) {
      setCoreOdValidationError(true);
    } else {
      setCoreOdValidationError(false);
    }
  };

  const onChangeReelOdSelect = (data) => {
    setSelectedReelOD(data);
    let coreOD = form.getFieldValue("core_OD");
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    if (data.length == 1) {
      let reelodConversion = orderDim_Rewinder_Unit_Conversion[data[0]?.value?.split(" ")[1]];
      let reelOdValue = data[0]?.value?.split(" ")[0] * reelodConversion;
      if ((coreOD && parseFloat(coreODValue)) > parseFloat(reelOdValue)) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (data.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < data.length; ind++) {
        let convertedValue = data[ind]?.value?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[data[ind]?.value?.split(" ")[1]];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);
      if (
        (coreODValue && parseFloat(coreODValue)) >
        (minValue && parseFloat(minValue))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    }
  };

  const removeReelOD = (data) => {
    let array = selectedReelOD;
    let newArray = array.filter((item) => {
      return !(item.value === data.value);
    });
    setSelectedReelOD(newArray);
    let coreOD = form.getFieldValue("core_OD");
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;
    if (newArray && newArray?.length == 1) {
      let reelodConversion =
        orderDim_Rewinder_Unit_Conversion[newArray[0]?.value?.split(" ")[1]];
      let reelOD = newArray[0]?.value?.split(" ")[0] * reelodConversion;

      if (
        (coreODValue && parseFloat(coreODValue)) >
        (reelOD && parseFloat(reelOD))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    } else if (newArray && newArray.length > 1) {
      let dataArr = [];
      for (let ind = 0; ind < newArray.length; ind++) {
        let convertedValue =
          newArray[ind]?.value?.split(" ")[0] *
          orderDim_Rewinder_Unit_Conversion[
          newArray[ind]?.value?.split(" ")[1]
          ];
        dataArr.push(convertedValue);
      }
      let minValue = Math.min(...dataArr);

      if (
        (coreODValue && parseFloat(coreODValue)) >
        (minValue && parseFloat(minValue))
      ) {
        setCoreOdValidationError(true);
      } else {
        setCoreOdValidationError(false);
      }
    }
  };

  const onMinReelODChange = (e) => {
    let rangeUnit = form.getFieldValue("reelOD_unit");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[rangeUnit];
    let reelOD = e.target.value ? e.target.value * minReelConversion : "";
    let coreOD = form.getFieldValue("core_OD");
    let coreodConversion = orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;

    if (reelOD != "" && ((parseFloat(reelOD)) < (coreODValue && parseFloat(coreODValue)))
    ) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }

    if (e.target.value != "" && (parseFloat(e.target.value) > parseFloat(form.getFieldValue("max_reel_od")))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onMaxReelODChange = (e) => {
    setRangeValidationError(false);
    if (e.target.value != "" && (parseFloat(e.target.value) < parseFloat(form.getFieldValue("min_reel_od")))
    ) {
      setReelODValidationError(true);
    } else {
      setReelODValidationError(false);
    }
  };

  const onRangeUnitChange = (e) => {
    let coreOD = form.getFieldValue("core_OD");
    let minReel = form.getFieldValue("min_reel_od");
    let minReelConversion = orderDim_Rewinder_Unit_Conversion[e];
    let reelODValue = minReel * minReelConversion;
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[coreOD?.split(" ")[1]];
    let coreODValue = coreOD?.split(" ")[0] * coreodConversion;

    if (
      (reelODValue && parseFloat(reelODValue)) <
      (coreODValue && parseFloat(coreODValue))
    ) {
      setRangeValidationError(true);
    } else {
      setRangeValidationError(false);
    }
  };

  const handleEditAction = (ele, ind) => {
    setIsEdit(true);
    setIndexValue(ind);
    form.setFieldsValue({ width: ele.width });
    form.setFieldsValue({ dimensionUnit: ele.sizeUnit });

    if (selectedType == "sheet") {
      setGrain(ele.grain);
      form.setFieldsValue(ele.grain);
      form.setFieldsValue({ length: ele.length });
    }

    if (ele.orderQty == "weight") {
      form.setFieldsValue({ weight: ele.weight });
      form.setFieldsValue({ weightUnit: ele.weightUnit });
      form.setFieldsValue({ order_upper_tolerance: ele.upper_tolerance });
      form.setFieldsValue({ order_lower_tolerance: ele.lower_tolerance });
      setDefaultLowerOrderTol(ele.lower_tolerance);
      setDefaultUpperOrderTol(ele.upper_tolerance);
      setOrderLowerTol(ele.calculated_lower_tol);
      setOrderUpperTol(ele.calculated_upper_tol);
      setUnitPlaceholder(ele.weightUnit);
    } else {
      form.setFieldsValue({ quantity: ele.quantity });
    }

    if (ele.outerDia == "range") {
      form.setFieldsValue({ min_reel_od: ele.min_reel_od });
      form.setFieldsValue({ max_reel_od: ele.max_reel_od });
      form.setFieldsValue({ reelOD_unit: ele.reel_od_unit });
    } else {
      ele?.orderQty == "reel" ? form.setFieldsValue({ reel_OD: ele.reelOD }) : setSelectedReelOD(ele.reelOD);
    }

  };

  const handleDeleteAction = (ind) => {
    let detailsArr = [];
    detailsArr = [...details];
    const updatedItems = detailsArr.filter((_, i) => i !== ind);
    setDetails(updatedItems);
  };

  const onSaveData = async () => {
    if (isEdit) {
      try {
        // Only validate relevant fields
        let orderSizeFields = [];
        orderSizeFields.push('width', 'dimensionUnit');
        if (selectedType == "reel") {
          if (orderQuantity == "weight") {
            let weightValuesArr = [
              'weight',
              'weightUnit',
              'order_upper_tolerance',
              'order_lower_tolerance'
            ];
            const updatedFields = orderSizeFields?.filter(field => field !== 'quantity')?.concat(weightValuesArr);
            orderSizeFields = updatedFields;
          } else {
            const updatedFields = orderSizeFields?.filter(field =>
              (field !== 'weight' && field !== 'weightUnit' && field !== 'order_upper_tolerance' && field !== 'order_lower_tolerance'))?.concat('quantity');
            orderSizeFields = updatedFields;
          }
        } else {
          orderSizeFields?.push('grain', 'length');
          if (orderQuantity == "weight") {
            let weightValuesArr = [
              'weight',
              'weightUnit',
              'order_upper_tolerance',
              'order_lower_tolerance',
            ];
            const updatedFields = orderSizeFields?.filter(field => field !== 'quantity')?.concat(weightValuesArr);
            orderSizeFields = updatedFields;
          } else {
            const updatedFields = orderSizeFields?.filter(field =>
              (field !== 'weight' && field !== 'weightUnit' && field !== 'order_upper_tolerance' && field !== 'order_lower_tolerance'))?.concat('quantity');
            orderSizeFields = updatedFields;
          }
        }

        const values = await form.validateFields(orderSizeFields);
        let detailsArr = [];
        detailsArr = [...details];
        detailsArr[indexValue]["width"] = form.getFieldValue("width");
        detailsArr[indexValue]["length"] = form.getFieldValue("length");
        detailsArr[indexValue]["sizeUnit"] = form.getFieldValue("dimensionUnit");
        detailsArr[indexValue]["orderQty"] = orderQuantity;
        detailsArr[indexValue]["outerDia"] = outerDiameter;
        detailsArr[indexValue]["coreOD"] = form.getFieldValue("core_OD");
        detailsArr[indexValue]["grain"] = form.getFieldValue("grain");
        detailsArr[indexValue]["rotation"] = grainChanges;
        detailsArr[indexValue]["grain_mixing"] = mixedGrain;

        if (orderQuantity == "weight") {
          detailsArr[indexValue]["upper_tolerance"] = form.getFieldValue("order_upper_tolerance");
          detailsArr[indexValue]["lower_tolerance"] = form.getFieldValue("order_lower_tolerance");
          detailsArr[indexValue]["calculated_upper_tol"] = orderUpperTol;
          detailsArr[indexValue]["calculated_lower_tol"] = orderLowerTol;
        }

        detailsArr[indexValue]["weight"] = form.getFieldValue("weight");
        detailsArr[indexValue]["weightUnit"] = form.getFieldValue("weightUnit");
        detailsArr[indexValue]["quantity"] = form.getFieldValue("quantity");

        if (outerDiameter == "range") {
          detailsArr[indexValue]["min_reel_od"] = form.getFieldValue("min_reel_od");
          detailsArr[indexValue]["max_reel_od"] = form.getFieldValue("max_reel_od");
          detailsArr[indexValue]["reel_od_unit"] = form.getFieldValue("reelOD_unit");
        } else {
          detailsArr[indexValue]["reelOD"] = (orderQuantity == "reel") ? form.getFieldValue("reel_OD") : selectedReelOD;
        }

        setDetails(detailsArr);

        // reset all the formcontrols
        form.resetFields([
          'width', 'length',
          'weight', 'quantity', 'min_reel_od', 'max_reel_od']);

        form.setFieldsValue({
          weightUnit: measurementData.data.units_management.weight.default,
          dimensionUnit: measurementData.data.units_management.length.default,
        });

        setOrderQuantity("weight");
        setUnitPlaceholder(measurementData.data.units_management.weight.default);
        form.setFieldsValue({ reelOD_unit: measurementData.data.units_management.length.default });
        setReelODValidationError(false);
        setCoreOdValidationError(false);
        setOrderUpperTol("");
        setOrderLowerTol("");
        setOuterDiameter("constant");

        if (selectedType == "reel") {
          if (reelCoreData) {
            form.setFieldsValue({
              reel_OD: reelCoreData.default_reel_od
                ? reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit
                : "",
            });
            form.setFieldsValue({
              core_OD: reelCoreData.default_core_id
                ? reelCoreData.default_core_id +
                " " +
                reelCoreData.default_core_unit
                : "",
            });
            reelCoreData.default_reel_od
              ? setSelectedReelOD([
                {
                  value:
                    reelCoreData.default_reel_od +
                    " " +
                    reelCoreData.default_reel_unit,
                },
              ])
              : setSelectedReelOD([]);
          }
        }
        if (selectedType == "sheet") {
          setGrain(
            grainToleranceData?.settings.order_types[1]?.grain === "long"
              ? "Long Grain"
              : "Short Grain"
          );
          form.setFieldsValue({
            grain:
              grainToleranceData?.settings.order_types[1]?.grain === "long"
                ? "Long Grain"
                : "Short Grain",
          });
        }

        if (orderQuantity == "weight") {
          setToleranceDisabled(
            grainToleranceData?.settings?.order_types[2]?.value
          );
          setDefaultUpperOrderTol(
            grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
              .upper_tolerance
          );
          setDefaultLowerOrderTol(
            grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
              .lower_tolerance
          );
          form.setFieldsValue({
            order_upper_tolerance:
              grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
                .upper_tolerance,
          });
          form.setFieldsValue({
            order_lower_tolerance:
              grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
                .lower_tolerance,
          });
        }

        setIsEdit(false);
      } catch (errorInfo) {
        // Validation errors automatically display inline
        console.log('Validation failed:', errorInfo);
      }
    } else {
      try {
        // Only validate relevant fields
        let orderSizeFields = [];
        orderSizeFields.push('width', 'dimensionUnit');
        if (selectedType == "reel") {
          if (orderQuantity == "weight") {
            let weightValuesArr = [
              'weight',
              'weightUnit',
              'order_upper_tolerance',
              'order_lower_tolerance'
            ];
            const updatedFields = orderSizeFields?.filter(field => field !== 'quantity')?.concat(weightValuesArr);
            orderSizeFields = updatedFields;
          } else {
            const updatedFields = orderSizeFields?.filter(field =>
              (field !== 'weight' && field !== 'weightUnit' && field !== 'order_upper_tolerance' && field !== 'order_lower_tolerance'))?.concat('quantity');
            orderSizeFields = updatedFields;
          }
        } else {
          orderSizeFields?.push('grain', 'length');
          if (orderQuantity == "weight") {
            let weightValuesArr = [
              'weight',
              'weightUnit',
              'order_upper_tolerance',
              'order_lower_tolerance',
            ];
            const updatedFields = orderSizeFields?.filter(field => field !== 'quantity')?.concat(weightValuesArr);
            orderSizeFields = updatedFields;
          } else {
            const updatedFields = orderSizeFields?.filter(field =>
              (field !== 'weight' && field !== 'weightUnit' && field !== 'order_upper_tolerance' && field !== 'order_lower_tolerance'))?.concat('quantity');
            orderSizeFields = updatedFields;
          }
        }

        const values = await form.validateFields(orderSizeFields);

        let detailsObj = {};
        let detailsArr = [];
        detailsArr = [...details];

        detailsObj["width"] = form.getFieldValue("width");
        detailsObj["length"] = form.getFieldValue("length");
        detailsObj["sizeUnit"] = form.getFieldValue("dimensionUnit");
        detailsObj["orderQty"] = orderQuantity;
        detailsObj["outerDia"] = outerDiameter;
        detailsObj["coreOD"] = form.getFieldValue("core_OD");
        detailsObj["grain"] = form.getFieldValue("grain");
        detailsObj["rotation"] = grainChanges;
        detailsObj["grain_mixing"] = mixedGrain;

        if (orderQuantity == "weight") {
          detailsObj["upper_tolerance"] = form.getFieldValue("order_upper_tolerance");
          detailsObj["lower_tolerance"] = form.getFieldValue("order_lower_tolerance");
          detailsObj["calculated_upper_tol"] = orderUpperTol;
          detailsObj["calculated_lower_tol"] = orderLowerTol;
        }

        detailsObj["weight"] = form.getFieldValue("weight");
        detailsObj["weightUnit"] = form.getFieldValue("weightUnit");
        detailsObj["quantity"] = form.getFieldValue("quantity");

        if (outerDiameter == "range") {
          detailsObj["min_reel_od"] = form.getFieldValue("min_reel_od");
          detailsObj["max_reel_od"] = form.getFieldValue("max_reel_od");
          detailsObj["reel_od_unit"] = form.getFieldValue("reelOD_unit");
        } else {
          detailsObj["reelOD"] = (orderQuantity == "reel") ? form.getFieldValue("reel_OD") : selectedReelOD;
        }


        detailsArr.push(detailsObj);
        setDetails(detailsArr);

        form.resetFields([
          'width', 'length',
          'weight', 'quantity', 'min_reel_od', 'max_reel_od']);

        form.setFieldsValue({
          weightUnit: measurementData.data.units_management.weight.default,
          dimensionUnit: measurementData.data.units_management.length.default,
        });

        setOrderQuantity("weight");
        setUnitPlaceholder(measurementData.data.units_management.weight.default);
        form.setFieldsValue({ reelOD_unit: measurementData.data.units_management.length.default });
        setReelODValidationError(false);
        setCoreOdValidationError(false);
        setOrderUpperTol("");
        setOrderLowerTol("");
        setOuterDiameter("constant");

        if (selectedType == "reel") {
          if (reelCoreData) {
            form.setFieldsValue({
              reel_OD: reelCoreData.default_reel_od
                ? reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit
                : "",
            });
            form.setFieldsValue({
              core_OD: reelCoreData.default_core_id
                ? reelCoreData.default_core_id +
                " " +
                reelCoreData.default_core_unit
                : "",
            });
            reelCoreData.default_reel_od
              ? setSelectedReelOD([
                {
                  value:
                    reelCoreData.default_reel_od +
                    " " +
                    reelCoreData.default_reel_unit,
                },
              ])
              : setSelectedReelOD([]);
          }
        }
        if (selectedType == "sheet") {
          setGrain(
            grainToleranceData?.settings.order_types[1]?.grain === "long"
              ? "Long Grain"
              : "Short Grain"
          );
          form.setFieldsValue({
            grain:
              grainToleranceData?.settings.order_types[1]?.grain === "long"
                ? "Long Grain"
                : "Short Grain",
          });
          setSelectedReelOD([]);
        }

        if (orderQuantity == "weight") {
          setToleranceDisabled(
            grainToleranceData?.settings?.order_types[2]?.value
          );
          setDefaultUpperOrderTol(
            grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
              .upper_tolerance
          );
          setDefaultLowerOrderTol(
            grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
              .lower_tolerance
          );
          form.setFieldsValue({
            order_upper_tolerance:
              grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
                .upper_tolerance,
          });
          form.setFieldsValue({
            order_lower_tolerance:
              grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
                .lower_tolerance,
          });
        }

      } catch (errorInfo) {
        // Validation errors automatically display inline
        console.log('Validation failed:', errorInfo);
      }
    }

  };

  const onCancel = () => {
    form.resetFields([
      'width', 'length',
      'weight', 'quantity', 'min_reel_od', 'max_reel_od']);

    form.setFieldsValue({
      weightUnit: measurementData.data.units_management.weight.default,
      dimensionUnit: measurementData.data.units_management.length.default,
    });

    setOrderQuantity("weight");
    setUnitPlaceholder(measurementData.data.units_management.weight.default);
    form.setFieldsValue({ reelOD_unit: measurementData.data.units_management.length.default });
    setReelODValidationError(false);
    setCoreOdValidationError(false);
    setOrderUpperTol("");
    setOrderLowerTol("");
    setOuterDiameter("constant");

    if (selectedType == "reel") {
      if (reelCoreData) {
        form.setFieldsValue({
          reel_OD: reelCoreData.default_reel_od
            ? reelCoreData.default_reel_od +
            " " +
            reelCoreData.default_reel_unit
            : "",
        });
        form.setFieldsValue({
          core_OD: reelCoreData.default_core_id
            ? reelCoreData.default_core_id +
            " " +
            reelCoreData.default_core_unit
            : "",
        });
        reelCoreData.default_reel_od
          ? setSelectedReelOD([
            {
              value:
                reelCoreData.default_reel_od +
                " " +
                reelCoreData.default_reel_unit,
            },
          ])
          : setSelectedReelOD([]);
      }
    }
    if (selectedType == "sheet") {
      setGrain(
        grainToleranceData?.settings.order_types[1]?.grain === "long"
          ? "Long Grain"
          : "Short Grain"
      );
      form.setFieldsValue({
        grain:
          grainToleranceData?.settings.order_types[1]?.grain === "long"
            ? "Long Grain"
            : "Short Grain",
      });
      setSelectedReelOD([]);
    }

    if (orderQuantity == "weight") {
      setToleranceDisabled(
        grainToleranceData?.settings?.order_types[2]?.value
      );
      setDefaultUpperOrderTol(
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .upper_tolerance
      );
      setDefaultLowerOrderTol(
        grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
          .lower_tolerance
      );
      form.setFieldsValue({
        order_upper_tolerance:
          grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
            .upper_tolerance,
      });
      form.setFieldsValue({
        order_lower_tolerance:
          grainToleranceData?.settings?.order_types[2]?.data?.order_tolerance
            .lower_tolerance,
      });
    }
  };

  const scrollToTop = () => {
    scrollRef.current.scrollIntoView();
  };

  const addSoDetails = async () => {
    const body = {
      date: props?.poDetails?.date,
      other_documents_location: props?.poDetails?.uploadedDocsArr,
      reference_number: props?.poDetails?.refNumber||'',
      dummy:true
    };
    console.log(body);
    await addSo(body)
      .then((response) => {
        console.log("so details", response);
        props.setSoNumber(response.data.number);
        soNo.current = response.data.number;
        // soDocumentsUpload(soNo);
        props.toasterAction({
          error: response.error,
          msg: `The SO ${response.data.number} is successfully saved <br>and the Order is added successfuly`,
        });
      })
      .catch((error) => {
        console.log("Error in adding new po:", error);
        props.toasterAction({
          error: error.response.error,
          msg: error.response.msg,
        });
        props.showToaster();
      });
  };

  const onFinish = (e) => {
    let ordersArr = [];
    let payloadObj = {};
    let reqPayload = {};
    details?.map((ele) => {
      payloadObj = {};
      let reelODArr = [];
      if(ele.orderQty !== "reel"){
        ele?.reelOD?.map((item) => {
          reelODArr.push(item.value);
        });
      }
      if (settingsData?.data?.order_creation_config?.dummy_orders?.product_selection == "specs") {
        payloadObj["product_specs"] = {
          "type": selectedType,
          "grade": selectedGrade,
          "quality": selectedQuality,
          "gsm": selectedGSM ? parseFloat(selectedGSM) : 0,
          "burst_factor": selectedBF ? parseFloat(selectedBF) : 0,
          "bulk": selectedBulk ? parseFloat(selectedBulk) : 0,
          "moisture": selectedMoisture ? parseFloat(selectedMoisture) : 0,
          "ply": selectedType == "reel" ? [parseInt(selectedPly)] : [1]
        }
      }
      payloadObj["dummy"] = true;
      payloadObj["type"] = selectedType;
      if (selectedType == "sheet") {
        payloadObj["length"] = ele?.length ? parseFloat(ele.length) : 0;
        payloadObj["grain"] = ele?.grain == "Long Grain" ? "long" : "short";
        payloadObj["rotation"] = ele.rotation;
        payloadObj["grain_mixing"] = ele.grain_mixing;
      }
      payloadObj["width"] = ele?.width ? parseFloat(ele.width) : 0;
      payloadObj["quantity_type"] = ele.orderQty == "weight" ? "weight" : "reel_sheet";
      payloadObj["weight"] = ele?.weight ? parseFloat(ele?.weight) : 0;
      payloadObj["no_of_reel_sheet"] = ele?.quantity ? parseFloat(ele.quantity) : 0;
      payloadObj["id_od_type"] = ele?.outerDia;
      if (ele?.outerDia === "range") {
        payloadObj["minimum_reel_od"] = ele?.min_reel_od ? parseFloat(ele?.min_reel_od) : 0;
        payloadObj["maximum_reel_od"] = ele?.max_reel_od ? parseFloat(ele?.max_reel_od) : 0;
      }
      payloadObj["inner_dia"] = ele?.coreOD;
      payloadObj["outer_dia"] = ele.orderQty === "reel" ? [ele?.reelOD] : reelODArr;
      if(selectedType == "reel"){
        payloadObj["ply"] = selectedPly ? parseInt(selectedPly) : "";
      }
      if (ele?.orderQty == "weight") {
        payloadObj["tolerances"] = {
          weight: {
            upper_tolerance: parseFloat(ele?.upper_tolerance),
            lower_tolerance: parseFloat(ele?.lower_tolerance),
            calculated_upper_tolerance: parseFloat(ele?.calculated_upper_tol),
            calculated_lower_tolerance: parseFloat(ele?.calculated_lower_tol),
            units: ele?.weightUnit,
          },
        }
      } else {
        payloadObj["tolerances"] = {};
      }

      payloadObj["so"] = soNo.current||props.soNumber;
      payloadObj["category"] = "so";
      payloadObj["comments"] = [];

      payloadObj["units"] = {
        ...(ele?.orderQty === "weight" && { weight: ele?.weightUnit }),
        length: ele?.sizeUnit,
        width: ele?.sizeUnit,
        per_weight_unit: "t",    
        dealer_price: "INR",
        net_price: "INR",
        customer_price: "INR",
        ...(ele?.outerDia == "range" && { minimum_reel_od: ele?.reel_od_unit }),
        ...(ele?.outerDia == "range" && { maximum_reel_od: ele?.reel_od_unit }),
      };
      ordersArr.push(payloadObj);
    });
    reqPayload = {
      "orders": ordersArr
    };
    addDummyOrders(reqPayload)
      .then((response) => {
        props.rendering(true);
        setTimeout(() => {
          props.toasterAction({
            error: response.error,
            msg: "The order is successfully added",
          });
          form.resetFields();
          setGrain("");
          setDefaultLowerOrderTol("");
          setDefaultUpperOrderTol("");
          setOrderUpperTol("");
          setOrderLowerTol("");
          setToleranceDisabled(false);
          setMixedGrain(false);
          setGrainChanges(true);
          setReelODValidationError(false);
          setCoreOdValidationError(false);
          setMixedGrainEnabled(false);
          setOrderQuantityTabArray([
            { label: "Weight", value: "weight" },
            {
              label:
                orderTypes.length > 0
                  ? `${capitalize(orderTypes[0].value)}s`
                  : "",
              value: orderTypes.length > 0 ? orderTypes[0].value : "",
            },
          ]);
          setUnitPlaceholder(
            measurementData.data.units_management.weight.default
          );
          form.setFieldsValue({
            weightUnit:
              measurementData.data.units_management.weight.default,
          });
          form.setFieldsValue({
            dimensionUnit:
              measurementData.data.units_management.length.default,
          });
          if (props?.page && props?.page == "poPage") {
            history("../order-records", {
              state: {
                poBackKey: true,
              },
            });
            props.onClose();
          } else {
            props.showToaster();
            props.onClose();
          }
        }, 0)
      })
      .catch((error) => {
        console.log("Error in adding new order:", error);
        if(error?.response?.data?.msg === 'product not found'){
            setProductErrModal(true);
        } else{
            props.toasterAction({
            error: error.response.data.error,
            msg: error.response.data.msg,
          });
          props.showToaster();
          props.onClose();
        }        
      });
  };

  const checkValidations = async () => {
    try {
      const excludeFields = [
        'weight',
        'weightUnit',
        'order_upper_tolerance',
        'order_lower_tolerance',
        'quantity',
        'width',
        'length',
        'dimensionUnit',
        'core_OD',
        'reel_OD',
        'reelOD_unit',
        'grain',
        'min_reel_od',
        'max_reel_od'
      ];
      const allFields = Object.keys(form.getFieldsValue());
      const fieldNamesToValidate = allFields.filter(
        (fieldName) => !excludeFields.includes(fieldName)
      );
      const values = await form.validateFields(fieldNamesToValidate);
      console.log(fieldNamesToValidate);
      if (values) {
        if (details?.length == 0) {
          setErrorModal(true);
        } else {
          !props.isOrders && await addSoDetails()
          onFinish(values);
        }
      }
    } catch (errorInfo) {
      scrollToTop();
      console.log('Validation failed for partial fields:', errorInfo);
    }
  };

  const cancelModal = () => {
    setErrorModal(false);
  };

  const cancelProductModal = () => {
    setProductErrModal(false);
  };

  return orderTypes.length > 0 &&
    measurementData &&
    reelCoreData &&
    settingsData &&
    selectedType &&
    grades?.length > 0 ? (
    <RightDrawerSidebar
      title="Add a new order"
      type="dummy_order"
      subtitle=""
      visible={props.visible}
      onClose={handleClose}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft" ref={scrollRef}>
          {visibleToaster && actionToaster.error && (
            <AlertContainer
              color="red toaster"
              icon={alertRed}
              msg={actionToaster.msg}
              closeIcon={true}
            />
          )}
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                // onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                form={form}
              >
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Product specifications</h5>
                    <p>Details of the product</p>
                  </div>
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "type"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "type"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.type?.visibility === true)) && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          // marginBottom: "-15px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Type
                        </p>
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          initialValue={selectedType ? selectedType : null}
                        >
                          <Select
                            placeholder="Select"
                            suffixIcon={<DownArrowDraw />}
                            onChange={handleType}
                            style={{ width: "331px", marginLeft: "30px" }}
                          >
                            {orderTypes?.map((orderType) => (
                              <Option key={orderType.value}>
                                {orderType.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "grade"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "grade"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.grade?.visibility === true)) && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Grade
                        </p>
                        <Form.Item
                          name="grade"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.grade?.value
                          }
                        >
                          <Select
                            placeholder="Select"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={handleGrade}
                            style={{ width: "331px", marginLeft: "30px" }}
                          >
                            {grades?.map((grade) => (
                              <Option key={grade.name}>{grade.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "quality"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "quality"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.quality?.visibility === true)) && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          // marginTop: "-14px",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Quality
                        </p>
                        <Form.Item
                          name="quality"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.quality?.value
                          }
                        >
                          <Select
                            placeholder="Select"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={handleQuality}
                            style={{ width: "331px", marginLeft: "30px" }}
                          >
                            {qualities?.map((quality) => (
                              <Option key={quality.name}>{quality.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "ply"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "ply"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.ply?.visibility === true)) &&
                    selectedType == "reel" && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Ply
                        </p>
                        <Form.Item
                          name="ply"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className="selectForm"
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.ply?.value
                          }
                        >
                          <Select
                            placeholder="Select"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={handlePly}
                            style={{ width: "331px", marginLeft: "30px" }}
                          >
                            {plyData?.map((item) => (
                              <Option key={item.value}>{item.name}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "gsm"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "gsm"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.gsm?.visibility === true)) && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: selectedType == "sheet" ? "-10px" : "-12px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          GSM
                        </p>
                        <Form.Item
                          name="gsm"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                              message:
                                "Only numeric characters are allowed upto 3 decimal points",
                            },
                          ]}
                          style={{ marginLeft: "30px", width: "332px" }}
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.gsm?.value
                          }
                        >
                          <Input
                            placeholder="Enter GSM of the product"
                            onChange={(e) => {
                              onGSMChange(e);
                            }}
                          />
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "burst_factor"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "burst_factor"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.burst_factor?.visibility === true)) &&
                    showBF && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          BF
                        </p>
                        <Form.Item
                          name="BF"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                              message: "Only numeric characters are allowed",
                            },
                          ]}
                          style={{ marginLeft: "30px", width: "332px" }}
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.burst_factor?.value
                          }
                        >
                          <Input
                            placeholder="Enter BF of the product"
                            onChange={(e) => {
                              onInputChange("BF", e);
                            }}
                          />
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "bulk"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "bulk"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.bulk?.visibility === true)) && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Bulk
                        </p>
                        <Form.Item
                          name="bulk"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                              message: "Only numeric characters are allowed",
                            },
                          ]}
                          style={{ marginLeft: "30px", width: "332px" }}
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.bulk?.value
                          }
                        >
                          <Input
                            placeholder="Enter Bulk of the product"
                            onChange={(e) => {
                              onBulkChange(e);
                            }}
                          />
                        </Form.Item>
                      </div>
                    )}
                  {(!settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                    "moisture"
                  ) ||
                    (settingsData?.data?.order_creation_config?.dummy_orders?.config?.hasOwnProperty(
                      "moisture"
                    ) &&
                      settingsData?.data?.order_creation_config?.dummy_orders
                        ?.config?.moisture?.visibility === true)) &&
                    showMoisture && (
                      <div
                        className="titleWithText"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-7px",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 8px 27px 0",
                            minWidth: "70px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-display-m)",
                          }}
                        >
                          Moisture
                        </p>
                        <Form.Item
                          name="moisture"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0|[1-9]\d*)(\.\d+)?$/,
                              message: "Only numeric characters are allowed",
                            },
                          ]}
                          style={{ marginLeft: "30px", width: "332px" }}
                          initialValue={
                            settingsData?.data?.order_creation_config
                              ?.dummy_orders?.config?.moisture?.value
                          }
                        >
                          <Input
                            placeholder="Enter moisture of the product"
                            onChange={(e) => {
                              onInputChange("moisture", e);
                            }}
                          />
                        </Form.Item>
                      </div>
                    )}
                </div>
                <div className="drawerField" style={{ borderBottom: "0px solid #edebe9" }}>
                  <div className="title-block" style={{
                    display: "flex", alignItems: "flex-start", justifyContent: "space-between",
                    alignItems: "center",
                  }}>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <h5 className="heading" style={{ margin: "0", fontSize: "15px", fontFamily: "var(--sf-pro-display-m)" }}>Order Size and Quantity</h5>
                      <p className="description" style={{ margin: "0", fontSize: "12px", color: "var(--color-text-title)", fontFamily: "var(--sf-pro-text)" }}>The width and quantity of the order</p>
                    </div>
                    <GlobalSet className="specialBtn adjCntBtn">
                      <Styled styled={{ display: "flex" }}>
                        <Button
                          className="textTypeBtn noMargin blackTxt"
                          onClick={onCancel}
                        >Cancel</Button>
                        {/* </Tooltip> */}
                      </Styled>
                      <Styled styled={{ display: "flex" }}>
                        <Button
                          className="textTypeBtn textBtnIcon"
                          onClick={onSaveData}
                        >
                          <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                          Save
                        </Button>
                      </Styled>
                    </GlobalSet>

                  </div>

                  <>
                    <Row className="centerAlign justifyCSBetween removeStar">
                      {selectedType === "sheet" && (
                        <Col span={8}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              label="Length"
                              name={`length`}
                              rules={[
                                {
                                  required: (selectedType === "sheet" || orderTypes[0]?.value === "sheet") ? true : false,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                  message:
                                    "Upto 2 decimal point values is accepted",
                                },
                                {
                                  pattern: new RegExp(
                                    /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                  ),
                                  message:
                                    "Length should be a number greater than zero",
                                },
                              ]}
                              className="dBlock"
                            >
                              <Input
                                placeholder="Length"
                                onChange={(e) => {
                                  onSizeChange(e, "length");
                                }}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      )}
                      <Col span={selectedType === "sheet" ? 8 : 13}>
                        <div className="boxFormType">
                          <Form.Item
                            label="Width"
                            name={`width`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d{0,2})?$/),
                                message:
                                  "Upto 2 decimal point values is accepted",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Width should be a number greater than zero",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Input
                              placeholder="Width"
                              onChange={(e) => {
                                onSizeChange(e, "width");
                              }}
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col span={selectedType === "sheet" ? 7 : 10}>
                        <div className="boxFormType unitSelect">
                          <Form.Item
                            label="Unit"
                            name={`dimensionUnit`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="dBlock"
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              onChange={(e) => {
                                onSizeChange(e, "sizeUnit");
                              }}
                            >
                              {dimesionUnitList.map((widthUnit) => (
                                <Option key={widthUnit} value={widthUnit}>
                                  {lengthUnit[widthUnit]?.displayName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    {orderTypes?.length
                      ? (selectedType === "sheet" ||
                        orderTypes[0]?.value === "sheet") && (
                        <div
                          className="drawerField"
                          style={{ marginTop: "-27px", borderBottom: "0px solid #edebe9" }}
                        >
                          <Form.Item
                            name={`grain`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className="selectForm"
                            style={{ marginBottom: 4 }}
                            initialValue={grainValue ? grainValue : null}
                          >
                            <Select
                              placeholder={"Select Grain"}
                              suffixIcon={<DownArrowDraw />}
                              onChange={(e) => onGrainChange(e)}
                            >
                              {grainTypeData.map((grainType) => (
                                <Option key={grainType}>{grainType}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <div className="italicsTitleWithText">
                            <p>
                              {grainValue === "Long Grain"
                                ? "The shorter side will be matched in deckle matching"
                                : grainValue === "Short Grain" &&
                                "The longer side will be matched in deckle matching"}
                            </p>
                          </div>
                          <div>
                            <Row className="centerAlign justifyCSBetween">
                              <Col>
                                <Checkbox
                                  style={{ borderRadius: "2px" }}
                                  onChange={(e) => {
                                    checkboxClicked(
                                      e,
                                      "mixedGrainChange"
                                    );
                                  }}
                                  checked={mixedGrain}
                                  disabled={isMixedGrainEnabled}
                                ></Checkbox>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Allow mixed grain for this order
                                </span>
                              </Col>
                            </Row>
                          </div>
                          <div style={{ marginBottom: "10px" }}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col>
                                <Checkbox
                                  onChange={(e) => {
                                    checkboxClicked(
                                      e,
                                      "grainChangesChange"
                                    );
                                  }}
                                  checked={grainChanges}
                                ></Checkbox>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Allow grain changes for this order
                                </span>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      )
                      : null}

                    <div
                      className="drawerField"
                      style={{ marginTop: selectedType == "reel" ? "-30px" : "-15px", borderBottom: "0px solid #edebe9" }}
                    >

                      <Form.Item
                        className=" switchRadio twoSwitch"
                        style={{
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <Radio.Group
                          options={orderQuantityTabArray}
                          optionType="button"
                          buttonStyle="solid"
                          value={orderQuantity}
                          onChange={(e) => {
                            handleQuantityChange(e);
                          }}
                        />
                      </Form.Item>
                      {orderQuantity === "weight" ? (
                        <>
                          <div style={{ position: "relative" }}>
                            <Row className="centerAlign justifyCSBetween" style={{ marginTop: "-8px" }}>
                              <Col span={13}>
                                <div className="boxFormType">
                                  <Form.Item
                                    name={`weight`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                                        message:
                                          "Only decimal characters are allowed",
                                      },
                                      {
                                        pattern: new RegExp(
                                          /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                        ),
                                        message:
                                          "Weight should be a number greater than zero",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Enter weight"
                                      onChange={(e) => {
                                        handleWeight(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={10}>
                                <div className="boxFormType ">
                                  <Form.Item
                                    name={`weightUnit`}
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      onChange={(e) => {
                                        onChangeWeightUnit(e);
                                      }}
                                    >
                                      {weightUnitList?.map((unitItem) => (
                                        <Option
                                          key={unitItem}
                                          value={unitItem}
                                        >
                                          {weightUnit[unitItem]?.displayName}
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </>
                      ) : (
                        <>
                          <Form.Item
                            style={{ marginTop: "-10px" }}
                            name={`quantity`}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message:
                                  "Only decimal characters are allowed",
                              },
                              {
                                pattern: new RegExp(
                                  /^(?!0+(\.0+)?$)\d+(\.\d+)?$/
                                ),
                                message:
                                  "Quantity should be a number greater than zero",
                              },
                            ]}
                            className=""
                          >
                            <Input
                              placeholder="Enter quantity"
                            // onChange={(e) => {
                            //   onQuantityValueChange(e);
                            // }}
                            />
                          </Form.Item>
                        </>
                      )}
                    </div>

                    {(orderQuantity === "weight" && isToleranceDisabled) &&
                      (<Collapse
                        expandIconPosition="right"
                        bordered={false}
                        style={{ backgroundColor: "white", marginTop: "-24px" }}
                      >
                        <Panel
                          header={
                          "Tolerance -" +
                          defaultLowerOrderTol +
                          " to +" +
                          defaultUpperOrderTol +
                          " %"
                        }
                          style={{ fontStyle: "italic", marginLeft: "-15px" }}
                        >
                          <Row
                            // style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={6} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Upper Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name={`order_upper_tolerance`}
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      validator(_, value) {
                                        if (parseFloat(value) == 0) {
                                          return Promise.reject(
                                            "Min upper tolerance should be atleast 1 %"
                                          );
                                        } else {
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                  className="dBlock"
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "35px" }}
                                    onChange={(e) => {
                                      onTolChange(e, "upper_tol");
                                    }}
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={10} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {orderUpperTol + " "}{" "}
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                          <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={6} className="blockBreak">
                              <div className="titleWithText">
                                <p
                                  style={{
                                    marginTop: "7px",
                                    fontStyle: "initial",
                                    fontSize: "12px",
                                    fontFamily: "var(--sf-pro-text)",
                                    color: "var(--color-text-title)",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Lower Tolerance{" "}
                                </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name={`order_lower_tolerance`}
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      validator(_, value) {
                                        if (parseFloat(value) == 0) {
                                          return Promise.reject(
                                            "Min lower tolerance should be atleast 1 %"
                                          );
                                        } else {
                                          return Promise.resolve();
                                        }
                                      },
                                    },
                                  ]}
                                  className="dBlock"
                                >
                                  <Input
                                    placeholder=""
                                    style={{ fontSize: "10px", height: "35px" }}
                                    onChange={(e) => {
                                      onTolChange(e, "lower_tol");
                                    }}
                                  />
                                </Form.Item>
                                <span
                                  className="nonEditable"
                                  style={{ fontSize: "13px", top: "6px" }}
                                >
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={10} className="blockBreak">
                              <Col
                                span={8}
                                className="blockBreak"
                                style={{ maxWidth: "45%", marginLeft: "15px" }}
                              >
                                <div className="titleWithText">
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "var(--sf-pro-text)",
                                      color: "var(--color-text-title)",
                                      lineHeight: "20px",
                                      marginTop: "7px",
                                      fontStyle: "initial",
                                      width: "104px",
                                    }}
                                  >
                                    {orderLowerTol + " "}{" "}
                                    {weightUnit[unitPlaceholder]?.displayName}
                                  </p>
                                </div>
                              </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>)}

                    <div
                      className="drawerField"
                      style={{
                        borderBottom: "0px solid #edebe9",
                        marginLeft: "-12px",
                        marginTop: "-15px"
                      }}
                    >
                      <div className="titleWithText">
                        <p style={{ marginLeft: "19px", marginBottom: "6px" }}>
                          Core OD
                        </p>
                        <Form.Item
                          name="core_OD"
                          rules={[]}
                          className="selectForm"
                        >
                          <Select
                            placeholder="Select Core OD"
                            suffixIcon={<DownArrowDraw />}
                            showSearch
                            optionFilterProp="children"
                            onChange={handleCoreOD}
                            style={{ width: "441px", marginLeft: "15px" }}
                          >
                            {coreValues?.map((data) => (
                              <Option key={data?.value}>{data?.value}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                        {coreOdValidationError ? (
                          <div
                            className="errorText"
                            style={{
                              color: "#ea4e2c",
                              marginLeft: "18px",
                              marginTop: "-22px",
                              marginBottom: "20px",
                            }}
                          >
                            Reel OD cannot be less than Core OD
                          </div>
                        ) : null}
                      </div>

                      <div
                        className=" switchRadio twoSwitch"
                        style={{
                          justifyContent: "center",
                          display: "flex",
                          marginRight: "0px",
                          marginLeft: "16px",
                          marginTop: "-13px"
                        }}
                      >
                        <Radio.Group
                          options={rewinderType}
                          optionType="button"
                          buttonStyle="solid"
                          value={outerDiameter}
                          disabled={
                            selectedType == "reel" && orderQuantity == "reel"
                          }
                          onChange={handleRewinderType}
                        />
                      </div>

                      {outerDiameter === "constant" ? (
                        selectedType == "reel" && orderQuantity == "reel" ? (
                          <div className="titleWithText">
                            <p
                              style={{
                                marginLeft: "19px",
                                marginBottom: "3px",
                                marginTop: "10px",
                              }}
                            >
                              Reel OD
                            </p>
                            <Form.Item
                              name="reel_OD"
                              rules={[]}
                              className="selectForm"
                            >
                              <Select
                                placeholder="Select Reel OD"
                                suffixIcon={<DownArrowDraw />}
                                showSearch
                                optionFilterProp="children"
                                onChange={handleReelOD}
                                style={{ width: "441px", marginLeft: "15px" }}
                              >
                                {reelValues?.map((data) => (
                                  <Option key={data?.value}>
                                    {data?.value}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        ) : (
                          <div>
                            <p
                              style={{
                                marginLeft: "19px",
                                marginBottom: "3px",
                                marginTop: "10px",
                              }}
                            >
                              Reel OD
                            </p>
                            <Col className="blockBreak" style={{ marginLeft: "15px" }}>
                              <div className="boxFormType">
                                <PaperMachineQualitySelect>
                                  <MultiSelectCard>
                                    <Multiselect
                                      className="multiQuality"
                                      options={reelValues}
                                      style={multiselectStyle}
                                      showArrow={true}
                                      selectedValues={selectedReelOD}
                                      displayValue={"value"}
                                      showCheckbox={true}
                                      onSelect={onChangeReelOdSelect}
                                      onRemove={onChangeReelOdSelect}
                                      hideSelectedList
                                      keepSearchTerm
                                    />
                                  </MultiSelectCard>
                                </PaperMachineQualitySelect>
                              </div>

                              <Col span={12}>
                                <PaperMachineGradeSelect>
                                  <div className="mainMachineGrade">
                                    {selectedReelOD &&
                                      selectedReelOD?.map((item, index) => {
                                        return (
                                          index <= 10 && (
                                            <span
                                              className={
                                                "MachineGradeSelect-active"
                                              }
                                            >
                                              {item.value}
                                              <Button
                                                className="textTypeBtn textBtnIcon paperButtonBg"
                                                onClick={() => {
                                                  removeReelOD(item);
                                                }}
                                              >
                                                <Iconmoon
                                                  icon="wrong"
                                                  size={14}
                                                  color="#EA655B"
                                                />
                                              </Button>
                                            </span>
                                          )
                                        );
                                      })}
                                  </div>
                                  {selectedReelOD &&
                                    selectedReelOD?.length > 10 &&
                                    selectedReelOD?.map((item, index) => {
                                      let tooltipData = "";
                                      for (
                                        let index = 10;
                                        index < selectedReelOD?.length;
                                        index++
                                      ) {
                                        const data = selectedReelOD[index];
                                        tooltipData =
                                          tooltipData + data.value + ", ";
                                      }
                                      tooltipData = tooltipData.substring(
                                        0,
                                        tooltipData.length - 1
                                      );
                                      return (
                                        index == 11 && (
                                          <Tooltip title={tooltipData}>
                                            {" "}
                                            <span
                                              style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              & {selectedReelOD.length - 10}{" "}
                                              More
                                            </span>
                                          </Tooltip>
                                        )
                                      );
                                    })}
                                </PaperMachineGradeSelect>
                              </Col>
                            </Col>
                          </div>
                        )
                      ) : (
                        <div style={{ marginTop: "10px", marginLeft: "14px" }}>
                          <Col span={24}>
                            <Row className="centerAlign justifyCSBetween">
                              <Col span={8} className="blockBreak">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Min Reel OD"
                                    name="min_reel_od"
                                    rules={[
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Min Reel OD"
                                      className={
                                        reelODValidationError
                                          ? "showErrorBorder"
                                          : ""
                                      }
                                      onChange={(e) => {
                                        onMinReelODChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={8} className="blockBreak">
                                <div
                                  className="boxFormType"
                                  style={{ marginBottom: "0" }}
                                >
                                  <Form.Item
                                    label="Max Reel OD"
                                    name="max_reel_od"
                                    rules={[
                                      {
                                        pattern: new RegExp(
                                          /^\d+(\.\d{0,3})?$/
                                        ),
                                        message:
                                          "Only Numeric value is possible upto 3 decimal point",
                                      },
                                    ]}
                                    className="dBlock"
                                  >
                                    <Input
                                      placeholder="Max Reel OD"
                                      className={
                                        reelODValidationError
                                          ? "showErrorBorder"
                                          : ""
                                      }
                                      onChange={(e) => {
                                        onMaxReelODChange(e);
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </Col>
                              <Col span={7} className="blockBreak">
                                <div className="boxFormType unitSelect">
                                  <Form.Item
                                    label="Unit"
                                    name="reelOD_unit"
                                    rules={[]}
                                    className="dBlock"
                                    style={{ width: "128px" }}
                                  >
                                    <Select
                                      placeholder="Unit"
                                      suffixIcon={<DownArrowDraw />}
                                      className="dBlock"
                                      onChange={(e) => {
                                        onRangeUnitChange(e);
                                      }}
                                    >
                                      {measurementData?.data.units_management.length.data?.map(
                                        (reelUnit) => (
                                          <Option
                                            key={reelUnit}
                                            value={reelUnit}
                                          >
                                            {
                                              lengthUnit[reelUnit]
                                                ?.displayName
                                            }
                                          </Option>
                                        )
                                      )}
                                    </Select>
                                  </Form.Item>
                                </div>
                              </Col>
                              {reelODValidationError ? (
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-19px",
                                  }}
                                >
                                  Max dia cannot be less than Min dia
                                </span>
                              ) : null}
                              {rangeValidationError ? (
                                <span
                                  className="errorText"
                                  style={{
                                    color: "#ea4e2c",
                                    marginTop: "-19px",
                                  }}
                                >
                                  Min Reel dia cannot be less than Core OD
                                </span>
                              ) : null}
                            </Row>
                          </Col>
                        </div>
                      )}
                    </div>
                  </>
                </div>
                <DetailFields>
                  <div className="groupDetailWrap qualityRow">
                    <Row gutter={[24, 24]} className="groupForm">
                      <Col span={24}>
                        {details?.map((ele, index) => {
                          return (
                            <>
                              <Row className="centerAlign" >
                                <Row style={{ width: '100%' }} >
                                  <Col span={18}>
                                    <div className="boxFieldTitle">
                                      <label>
                                        {`Combination ${index + 1}`}{" "}
                                      </label>
                                    </div>
                                  </Col>
                                  <Col span={6}>
                                    <div className="boxFormType">
                                      <GlobalSet>
                                        <Styled
                                          className="dFlex centerAlignBtn"
                                          style={{ paddingLeft: "35px" }}
                                        >
                                          <Button
                                            onClick={(e) => {
                                              handleEditAction(ele, index);
                                            }}
                                            className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                          >
                                            <Iconmoon
                                              icon="edit"
                                              size={17}
                                              color="#605E5C"
                                            />
                                          </Button>
                                          <Button
                                            onClick={() => handleDeleteAction(index)}
                                            className="textTypeBtn edit-btn edit-tooltip deleteQtyBtn"
                                          >
                                            <Iconmoon
                                              icon="delete"
                                              size={17}
                                              color="#605E5C"
                                            />
                                          </Button>
                                        </Styled>
                                      </GlobalSet>
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="centerAlign" style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                  <Col span={14} style={{ fontSize: '12px' }}>
                                    Size:
                                    {selectedType == "sheet" ? (ele?.width + " x " + ele?.length + " " + lengthUnit[ele?.sizeUnit]?.displayName) : (ele?.width + " " + lengthUnit[ele?.sizeUnit]?.displayName)}
                                  </Col>
                                  <Col span={10} style={{ fontSize: '12px' }}>
                                    Quantity:{" "}
                                    {ele?.orderQty == "weight" ? (ele?.weight + " " + capitalize(weightUnit[ele?.weightUnit].displayName)) : (ele?.quantity + " " + capitalize(selectedType) + "s")}
                                  </Col>
                                </Row>
                              </Row>
                            </>
                          )
                        })}
                      </Col>
                    </Row>
                  </div>
                </DetailFields>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      // htmlType="submit"
                      className="themeBtn"
                      onClick={() => checkValidations()}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Add Order{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
      <ModalPopup visible={errorModal}>
        <div className="Popup-img">
          <img src={warning} />
        </div>
        <div className="Popup-content">
          <span>Missing Order</span>
          <p>Atleast one size must be added
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => cancelModal()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
        </div>
      </ModalPopup>
      <ModalPopup visible={productErrModal}>
        <div className="Popup-img">
          <img src={warning} />
        </div>
        <div className="Popup-content">
          <span>Missing Product</span>
          <p>No product found match product specification 
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => cancelProductModal()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  ) : null;
};
export default AddNewDummyOrderDrawer;
